import { useContext, useState, useEffect } from "react"
import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../../Utils/Utils'
import OneModal from "../../../../Components/OneModal/OneModal"
import UsuarioSelect from "./UsuarioSelect/UsuarioSelect"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"

export const CadastroEquipe = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const [usuarios, setUsuarios] = useState(null)

    const getDadosIniciais = (msg) => {
        if (msg.cmd == "buscarListagens") {
            if (msg.data.status == true) {
                setUsuarios(msg.data.listagens.usuario)
            } else if (msg.data.status == "error") {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            } else if (msg.data.status == false) {
                showNotify("error", msg.message)
                setOpenCadastro(false)
            }
        } else if (msg.cmd == "buscarEquipe") {
            if (msg.data.status) {
                setInitialData(msg.data.equipe)
            } else {
                showNotify(msg.message)
                setOpenCadastro(false)
            }
        }
    }

    useEffect(() => {
        if ((initialData || idToEdit == null) && usuarios) {
            setLoading(false)
        }
    }, [initialData, usuarios])

    useEffect(() => {
        addRoute("buscarListagens", getDadosIniciais)
        sendWs("buscarListagens", { listagens: { usuario: ["id", "nome", "img_perfil"] } })
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            addRoute("buscarEquipe", getDadosIniciais)
            sendWs("buscarEquipe", { id: stringId, listar: true })
        }
    }, [])

    const responseSumbit = (msg) => {
        const message = 'Não é possível desativar a equipe enquanto houver usuários, condomínios ou eventos vinculados.'
        if (msg.data.message == message) {
            showNotify('error', message, { autoClose: 5000 })
            setOpenCadastro(false)
        } else if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            setIdToEdit(null)
            setOpenCadastro(false)
            showNotify("success", "Equipe salva com sucesso!")
            sendWs("buscarTodasEquipes")
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("criarEquipe", responseSumbit)
    addRoute("editarEquipe", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleFiltroEventos = (newUsuarios) => {
        setFormData({ ...formData, usuarios: newUsuarios })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData
            if (data.usuarios) {
                data.usuarios = data.usuarios.map((usuario) => usuario.id)
            }
            sendWs("editarEquipe", { equipe: data })
        } else {
            delete data.id
            if (data.usuarios) {
                data.usuarios = data.usuarios.map((usuario) => usuario.id)
            }
            sendWs("criarEquipe", { equipe: data })
        }
    }

    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            loading={loading}
            titleText="Equipes"
            FooterButtons={FooterButtons}
        >
            <form
                id="equipes-form"
                onSubmit={handleSubmit}
            >
                <Grid
                    xs={12}
                    rowSpacing={0}
                    columnSpacing={1}
                    container
                    gap={0.5}
                    sx={{ maxWidth: '600px' }}
                >
                    <Grid container xs={12} sx={{ alignItems: 'center' }}>
                        <Grid container xs={12} sm={3} sx={{ alignItems: 'center' }}>
                            <Grid xs={3} sm={6}>
                                <Typography fontSize="13px" fontWeight='400' >Código: </Typography>
                            </Grid>
                            <Grid xs={9} sm={5}>
                                <OneInput defaultValue={initialData?.id} onChange={handleChange} readOnly={true} disabled={true} name={"id"}/>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sm={3} sx={{ alignItems: 'center' }}>
                            <Grid xs={12} sm={4} lg={4}>
                                <Typography fontSize="13px" fontWeight='400' >Ativo: </Typography>
                            </Grid>
                            <Grid xs={12} sm={4} lg={4}>
                                <OneSwitch defaultChecked={initialData?.ativo} onChange={handleChange} name={"ativo"} />
                            </Grid>
                        </Grid>
                        <Grid container xs={12} sm={12} sx={{ alignItems: 'center', marginTop: { xs: '5px', lg: '5px' } }}>
                            <Grid xs={12} sm={1.5} lg={1.5}>
                                <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                            </Grid>
                            <Grid xs={12} sm lg>
                                <OneInput
                                    defaultValue={initialData?.descricao}
                                    onChange={handleChange}
                                    autoFocus
                                    maxLength="50"
                                    required
                                    name={"descricao"}
                                />
                            </Grid>
                        </Grid>
                        <Grid container xs={12} lg={12} sx={{ alignItems: 'center', marginTop: { xs: '5px', lg: '5px' } }}>
                            <Grid xs={12} sm={1.5} lg={1.5}>
                                <Typography fontSize="13px" fontWeight='400' >Usuários: </Typography>
                            </Grid>
                            <Grid xs={12} sm lg>
                                <UsuarioSelect
                                    callback={handleFiltroEventos}
                                    defaultValue={initialData?.usuarios}
                                    name={"usuarios"}
                                    label={"nome"}
                                    value={"id"}
                                    options={usuarios}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </OneModal>
    )
}

export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="equipes-form" type="submit">Salvar</Button>
        </Grid>
    )
}
